// extracted by mini-css-extract-plugin
export default {"mc":"425px","sm":"768px","md":"1024px","lg":"1268px"};